// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2uGnA","select":"Header_select__2veod","clinic":"Header_clinic__2HfWC"};